// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router';
import Login from '@/views/Login.vue';
import Home from '@/views/Home.vue';
import AgentManagement from '@/views/AgentManagement.vue';
import MerchantManagement from '@/views/MerchantManagement.vue';
import TiepaiManagement from '@/views/TiepaiManagement.vue';
import AboutUs from '@/views/AboutUs.vue';
import ContactUs from '@/views/ContactUs.vue';
import { auth } from '@/utils/auth.js';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'Login', component: Login },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'agent-management',
        name: 'AgentManagement',
        component: AgentManagement,
      },
      {
        path: 'merchant-management',
        name: 'MerchantManagement',
        component: MerchantManagement,
      },
      {
        path: 'tiepai-management',
        name: 'TiepaiManagement',
        component: TiepaiManagement,
      },
      // 抽佣管理下的页面
      {
        path: 'sub-merchant-list',
        name: 'SubMerchantList',
        component: () => import('@/views/SubMerchantList.vue'),
      },
      {
        path: 'profit-sharing',
        name: 'ProfitSharing',
        component: () => import('@/views/ProfitSharing.vue'),
      },
      {
        path: 'order-list',
        name: 'OrderList',
        component: () => import('@/views/OrderList.vue'),
      },
      {
        path: 'wx-pay-config',
        name: 'WxPayConfig',
        component: () => import('@/views/WxPayConfig.vue'),
      },
      // 系统配置下的页面
      {
        path: 'user-profile',
        name: 'UserProfile',
        component: () => import('@/views/UserProfile.vue'),
      },
      {
        path: 'storage-config',
        name: 'StorageConfig',
        component: () => import('@/views/StorageConfig.vue'),
      },
      {
        path: 'map-config',
        name: 'MapConfig',
        component: () => import('@/views/MapConfig.vue'),
      },
      // 新增：接口配置（AI配置）
      {
        path: 'ai-config',
        name: 'AiConfig',
        component: () => import('@/views/AiConfig.vue'),
      },
      // 在 children 数组中添加以下路由
      {
        path: 'mini-copyright-config',
        name: 'MiniCopyrightConfig',
        component: () => import('@/views/MiniCopyrightConfig.vue'),
      }, 
      // 在 children 数组中添加成本管理路由
      {
        path: 'cost-config',
        name: 'CostConfig',
        component: () => import('@/views/CostConfig.vue'),
      },          
      {
        path: 'about-us',
        name: 'AboutUs',
        component: AboutUs,
      },
      {
        path: 'contact-us',
        name: 'ContactUs',
        component: ContactUs,
      },
    ],
    meta: { requiresAuth: true },
  },
  { path: '/:pathMatch(.*)*', redirect: '/login' },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!auth.getStoredUser();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next('/login');
    } else {
      next();
    }
  } else {
    if (isLoggedIn && to.path === '/login') {
      next('/home/merchant-management');
    } else {
      next();
    }
  }
});

export default router;